/* eslint-disable max-depth */
/* eslint-disable array-callback-return */
import { ActionRuleParams } from '../../types';
import { hasKitchenReferenceRule } from '../../helpers';

export const fridge15TrimKit = (params: ActionRuleParams): void => {
	// console.log('rule:func:-> fridge21TrimKit', params);
	const { refMap } = params;
	const { panelItemGroups, panelItemGroup } = refMap;
	const runRule = hasKitchenReferenceRule({ refMap, rule: 'Fridge15TrimKit' });
	if (runRule) {
		const eligibleItems = panelItemGroups.children.map((group) => group.items.children.filter((item) => item.item.component.rules.action.includes('Fridge15TrimKit')))
			.filter((group) => group.length > 0);
		const fridgeSupportPromos = refMap.kitchen.itemizedMsrp.items.filter((item) => item.sku === 'C115TK');
		let newTrim = null;
		if (eligibleItems.length > fridgeSupportPromos.length) {
			newTrim = panelItemGroup.items.newFromSku('C115TK');
			eligibleItems.forEach((item) => {
				if (item) {
					item.forEach((i) => {
						console.log('trim added to', i);
						// i.sidePadding = 2.25;
					});
				}
			});
			const existingItemCenters = panelItemGroups.children
				.flatMap((group) => group.items.children)
				.map((item) => item.center);

			if (!existingItemCenters.includes(newTrim.center)) {
				panelItemGroup.items.delete(newTrim.id);
				newTrim = null;
			}
		} else {
			panelItemGroup.items.children.forEach((item) => {
				if (item.item.sku === 'C115TK') {
					panelItemGroup.items.delete(item.id);
				}
			});
		}
	}
};
